module.exports = __webpack_public_path__ + "static/eshop2-e03057473a45778bd0d0bcdf81ba7dd4.gif";